import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy, SimpleChanges, AfterViewChecked } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-collapsible-card',
  templateUrl: './collapsible-card.component.html',
  styleUrls: ['./collapsible-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollapsibleCardComponent implements OnInit, AfterViewChecked {
  @Input() id: string;
  @Input() title: string;
  @Input() badge: string = null;
  @Output() onExpand = new EventEmitter<any>();
  @Output() onRemove = new EventEmitter<any>();
  @Input() visible: boolean = false;
  @Input() loading: boolean = false;
  @Input() danger: boolean = false;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void { }

  toggleContent() {
    this.onExpand.emit();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.cdr.detectChanges();
  }

  onRemoveSelection(e, b) {
    e.stopPropagation();
    this.onRemove.emit(b);
  }
}